import React, { ReactElement } from 'react';
import { ButtonColor, ButtonContainer } from '../../../../button';
import { useTranslations } from '../../../../translations';
import { IconAttentionComponent } from '../../../../icons';
import { getSubscriptionCoursesHref } from '../../customersSubscriptionPopup.helper';
import {
  CustomersSubscriptionPopup,
  CustomersSubscriptionPopupControls,
  CustomersSubscriptionPopupSubtitle,
  CustomersSubscriptionPopupTitle,
} from '../../customersSubscriptionPopup.styled';
import { useCustomersSubscriptionPopupContext } from '../../customersSubscriptionPopup.context';
import { publicConfig } from '../../../../../services';
import { projectTypes } from '../../../../../constants';

export const AlreadyActivated = (): ReactElement => {
  const translations = useTranslations();
  const { handleClosePopup } = useCustomersSubscriptionPopupContext();

  return (
    <CustomersSubscriptionPopup>
      <IconAttentionComponent width={48} height={48} fillColor="#201926" />
      <CustomersSubscriptionPopupTitle>
        {translations.your_subscription_is_already_activated}
      </CustomersSubscriptionPopupTitle>
      <CustomersSubscriptionPopupSubtitle>
        {translations.your_can_choose_any_from_subscription}
      </CustomersSubscriptionPopupSubtitle>
      <CustomersSubscriptionPopupControls>
        <ButtonContainer
          fullWidth
          href={getSubscriptionCoursesHref()}
          target={
            publicConfig.APP_TYPE !== projectTypes.courses
              ? '_blank'
              : undefined
          }
          title={translations.subscription_courses}
          color={ButtonColor.purple}
          borderRadius={100}
          onClick={handleClosePopup}
        />
      </CustomersSubscriptionPopupControls>
    </CustomersSubscriptionPopup>
  );
};
